export default "__VITE_ASSET__tWYsxnta__"